<template>
  <div style="max-width: 375px; margin: 0 auto;">
    <div id="buttonDiv" style="margin: 0 auto;"></div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
    ...mapGetters("auth/login", [
      "getInProgress",
      "getSuccess",
      "getErrorMessages",
    ]),
  mounted() {
    // eslint-disable-next-line
    google.accounts.id.initialize({
      client_id:
        "770774343850-rkcunkpvcqfckoitqdf4lem4rr4corft.apps.googleusercontent.com",
        callback: this.handleCredentialResponse,
    });
    // eslint-disable-next-line
    google.accounts.id.renderButton(
      document.getElementById("buttonDiv"),
      {
        theme: "outline",
        width: 375,
        text: "continue_with",
        logo_alignment: "left",
      }
    );
    // eslint-disable-next-line
    google.accounts.id.prompt(); // also display the One Tap dialog
  },
  methods: {
    handleCredentialResponse(response) {
      this.loginAction(response.credential);
    },
    loginAction(jwt) {
      this.logIn({ googleToken: jwt, redirect: this.$route.query.redirect });
    },
    ...mapActions("auth/login", ["logIn"]),
  },
};
</script>